import script from "./BaseFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./BaseFormComponent.vue?vue&type=style&index=0&id=11f91b48&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f91b48"]])

export default __exports__